import React from 'react';
import { Icon } from 'vetrf-ui';
import styles from 'components/Timeline/Timeline.module.scss';
import {
  FunctionPermissions,
  MovementHistoryItem,
} from '../../../../../../../../gmpRegistry/api/params';

type RequestMotionItemProps = {
  item: MovementHistoryItem;
  permissions: FunctionPermissions;
};

export const RequestMotionItem = ({ item, permissions }: RequestMotionItemProps) => (
  <>
    {item?.documentType?.id && (
      <div>
        <Icon color="blue" icon="file" size={150} />
        <span className={styles.documentName}>{item.documentType.name}</span>
        {item.documentNumber && <span> №{item.documentNumber} </span>}
        {item.documentDate && <span> от {item.documentDate}</span>}
      </div>
    )}
    {permissions.edit && item?.operationUser && (
      <div>
        Пользователь: {item.operationUser.fio}
        {item.operationDate ? ` (${item.operationDate.slice(0, 10)})` : ''}
      </div>
    )}
  </>
);
